export default __webpack_public_path__ + "f7f7539d45f788225b9aeb945f1b6b54.svg";